module.exports = __webpack_public_path__ + "img/service-bg.abdeefb6.png";